import { render, staticRenderFns } from "./StoreHeader.vue?vue&type=template&id=55ca7f5e&scoped=true"
import script from "./StoreHeader.vue?vue&type=script&lang=js"
export * from "./StoreHeader.vue?vue&type=script&lang=js"
import style0 from "./StoreHeader.vue?vue&type=style&index=0&id=55ca7f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca7f5e",
  null
  
)

export default component.exports